<template>
  <div
    class="flex h-9 items-center justify-center px-4 bg-paper-primary rounded-full cursor-pointer border border-filter-outline text-md text-nowrap hover:bg-filter-bg-hover"
    :class="props.selected ? '!bg-filter-bg' : ''"
  >
    {{ props.label }}
  </div>
</template>

<script setup>
import { ref, reactive, watch } from "vue";
import { Button, Icon, FilterDropdown, BaseInput } from "@/components";

const emit = defineEmits(["clear-filter", "clear-all-filters", "apply-filters"]);

const activeFilter = ref(null);

const props = defineProps({
  value: {
    type: [String, Object, Boolean, null],
    default: "",
  },
  // v-model support
  modelValue: {
    type: [String, Object, Boolean, null],
    default: "",
  },
  label: {
    type: String,
    default: "Pill",
  },
  selected: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: "md",
  },
});
</script>
